/** @format */

import {Typography} from '@mui/material';

import {NameIdContainer, IdText} from './styles';

interface NameIdCellProps {
  name: string | null;
  id?: string | null;
}

const NameIdCell = ({name, id}: NameIdCellProps) => {
  if (!id) return '—';

  return (
    <NameIdContainer>
      {name && <Typography variant='body2'>{name}</Typography>}
      <IdText>id{id}</IdText>
    </NameIdContainer>
  );
};

export default NameIdCell;
